<script>
	import Icon from '@iconify/svelte';
	import { Notification } from 'svelte-ux';
	import { _ } from 'svelte-i18n';
	import { dev } from '$app/environment';

	export let message = {};

	// $: if (message?.status !== undefined) {
	// 	setTimeout(() => {
	// 		message = {};
	// 	}, 5000);
	// }
</script>

<div class="max-w-xl fixed right-2 bottom-2 p-4 ml-auto z-[100] overflow-hidden">
	<Notification open={message?.status !== undefined} closeIcon>
		<div slot="icon">
			{#if message?.status === 200}
				<Icon icon="fa6-solid:circle-check" class="text-green-500 text-3xl" />
			{:else}
				<Icon icon="fa6-solid:circle-xmark" class="text-red-500 text-3xl" />
			{/if}
		</div>
		<div slot="title">
			<div class="text-space-black font-semibold -mb-1">
				{$_('toastMessage.message')}: {message?.message}
			</div>
		</div>
		<div slot="description">
			{#if message?.status !== 200 || dev}
				<div class="text-dark-gray mt-1">{$_('toastMessage.status')}: {message?.status}</div>
				<div class="text-dark-gray break-words break-all italic">
					{$_('toastMessage.rawResponse')}: {JSON.stringify(message?.raw)}
				</div>
			{/if}
		</div>
	</Notification>
</div>
